import { Box, Center, Circle, Float, HStack, Icon, IconButton, Link as ChakraLink, Show } from "@chakra-ui/react";
import { FiShoppingBag } from "react-icons/fi";
import { AiOutlineMenu } from "react-icons/ai";
import Image from "next/image";
import { openDrawer } from "@/shared/store/drawer";
import { I18nLink } from "../i18n/I18nLink";
import Wrapper from "./Wrapper";
import { useUnit } from "effector-react";
import { $shopState } from "@/shared/store/shop";
import HeaderSearchBar from "./HeaderSearchBar";
import { useTranslations } from "next-intl";

export default function Header() {
  const t = useTranslations();
  const { cart, favorites } = useUnit($shopState);
  return (
    // Шапка
    <Wrapper asChild>
      <HStack
        gap={8}
        w={"100%"}
        py={"10px"}
        borderBottom={"1px solid #CDCDCD"}
        position="sticky" // или "fixed"
        top={0}
        zIndex={10}
        bg="white"
      >
        <ChakraLink
          as={I18nLink}
          href="/"
        >
          <Center flexShrink={0}>
            <Image
              src="/logo.svg"
              alt="QREP Logo"
              width={40}
              height={40}
              style={{ width: "auto", height: "auto" }}
              priority
            />
          </Center>
        </ChakraLink>
        <HStack as={"nav"} w={"100%"} justifyContent={"space-between"}>
          <HStack gap={6} display={{ base: "none", md: "flex" }}>
            {[
              { href: "/shop", label: t('catalog') },
              { href: "/shop/lookbook", label: t('lookbook') },
              { href: "/shop/giftboxes", label: t('gift_boxes') },
              { href: "/shop?filter[onSale]=true", label: t('sale'), color: 'accent.red' },
              { href: "/stores", label: t('stores') },
              { href: "/shop/kids", label: t('kids') },
              { href: "/shop/school", label: t('school') },
            ].map((item, idx) => (
              <HStack key={idx} gap={4}>
                <Box
                  w="4px"
                  h="4px"
                  borderRadius="full"
                  bg="gray.solid"
                />
                <ChakraLink asChild textTransform={'lowercase'} textStyle={"md"} color={item.color}>
                  <I18nLink href={item.href} prefetch={true}>{item.label}</I18nLink>
                </ChakraLink>
              </HStack>
            ))}
          </HStack>
          <HStack alignSelf={"center"} gap={{ base: "8px", md: "16px" }} flexGrow={1} justifyContent={"flex-end"}>
            {/* Кнопки */}
            <HeaderSearchBar />

            <IconButton aria-label="Open cart" variant={"plain"} onClick={() => openDrawer({ type: "main", tab: "cart" })} size="xs">
              <Icon boxSize="6"><FiShoppingBag /></Icon>
              <Show when={cart.count > 0}>
                <Float placement={"top-end"} offset={"7px"}>
                  <Circle size="5" bg="brand" color="white">
                    {cart.count}
                  </Circle>
                </Float>
              </Show>
            </IconButton>
            <IconButton aria-label="Open menu" variant={"plain"} onClick={() => openDrawer({ type: "menu" })} size="xs">
              <Icon boxSize="6"><AiOutlineMenu /></Icon>
            </IconButton>
          </HStack>
        </HStack>
      </HStack>
    </Wrapper>
  )
};